// extracted by mini-css-extract-plugin
export var md = "_1m-4";
export var semantic = "_1m-5";
export var sm = "_1m-3";
export var text = "_1m-6";
export var toggleInput = "_1m-0";
export var toggleSwitch = "_1m-1";
export var xs = "_1m-2";